const Vue = require('vue').default

var PageCommon = {
  data: function () {
    return {
      isFixed: false,
      isMenuopen: false,
      thr: 0,
      isSubMenuopen: false,
    }
  },
  mounted: function () {
    this.$nextTick(() => {
      const mql = window.matchMedia('(max-width: 769px)');
      this.func(mql);
      mql.addListener(this.func);
      window.addEventListener('resize', this.handleResize)
    });
    this.jsanchor();
  },

  methods: {
    handleResize: function() {
      this.thr = document.getElementById('page-header').offsetHeight;
    },
    func(mql) {
      if (mql.matches) {
        this.thr = document.getElementById('page-header').offsetHeight;
      } else {
        this.thr = document.getElementById('page-header').offsetHeight - document.querySelector('.page-fixedmenu').offsetHeight - 20;
      }
    },
    handleScroll: function (evt, el) {

      if (window.scrollY > this.thr) {
        this.isFixed = true
      } else {
        this.isFixed = false
      }
    },
    jsanchor: function () {
      const _flag = this.breakpoint;
      let _btn = document.querySelectorAll(".js-anchor");
      for (let i = 0; i < _btn.length; i++) {
        _btn[i].addEventListener('click', function (e) {
          e.preventDefault();
          const _trg = this.hash;
          const _trgE = document.querySelector(_trg);
          const _rectTop = _trgE.getBoundingClientRect().top;
          const _offsetTop = window.pageYOffset;
          let _buffer = 0;
          if (_flag == false) _buffer = _buffer + 0;
          const _pos = _rectTop + _offsetTop - _buffer;
          window.scrollTo({
            top: _pos,
            left: 0,
            behavior: "smooth"
          });
        }, false);
      }
    },
  }
}

module.exports = PageCommon